<template>
    <div>
        <ApiForm
            :url="
                urlFactory.makeCompanyUserUpdateServicesUrl(
                    companyUserAggregate.companyUser.id,
                    origin,
                )
            "
            method="POST"
            ref="apiFormRef"
        >
            <ServiceCheckboxTable
                :services="services"
                :requestInputName="`${RequestBodyKeyEnum.App_CompanyUser_Services_Ids}[]`"
                :isServiceSelectedCallback="
                    (serviceId: ServiceID) =>
                        companyUserAggregate.isServiceSelected(serviceId)
                "
            />
        </ApiForm>

        <div class="flex items-center justify-end mt-4">
            <Button
                @click="apiFormRef?.submit()"
                :loading="apiFormRef?.loading.valueOf()"
                iconName="save"
            >
                Save
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType, ref } from 'vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import Service from '@/App/Service/Entity/Service'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Button from '@/Shared/Component/Button.vue'
    import { EditServiceOriginEnum } from '@/Shared/AutoGenerated/Main'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import ServiceCheckboxTable from '@/App/Service/Component/Service/ServiceCheckboxTable.vue'
    import ServiceID from '@/App/Service/Entity/ServiceID'

    const props = defineProps({
        companyUserAggregate: {
            type: Object as PropType<CompanyUserAggregate>,
            required: true,
        },
        services: {
            type: Object as PropType<Service[]>,
            required: true,
        },
        origin: {
            type: String as PropType<EditServiceOriginEnum>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
